<template id="client-edit">
  <div class="maxw">
    <h2>Editar client</h2>
    <b-form v-on:submit.prevent="updateClient">
      <b-tabs content-class="mt-3" fill>
        <b-tab title="Dades Comercials" active>
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Nom comercial:"
                label-for="input-nombre"
              >
                <b-form-input
                  id="input-nombre"
                  v-model="cliente.nombre"
                  required
                  autofocus
                  placeholder="Enter name"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Pais:">
                <b-form-select
                  v-model="cliente.pais"
                  :options="paises"
                  value-field="name"
                  text-field="name"
                >
                  <template #first>
                    <b-form-select-option :value="null"
                      >-- Seleccione un País --</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Adreça:"
                label-for="textarea-direccion"
              >
                <b-form-textarea
                  id="textarea-direccion"
                  v-model="cliente.direccion"
                  placeholder="Escriure Adreça Oficines - No fiscal"
                  rows="2"
                  max-rows="3"
                  maxlength="200"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="CP:"
                label-for="input-cp"
              >
                <b-form-input
                  id="input-cp"
                  v-model="cliente.cp"
                  maxlength="5"
                  placeholder="Escriure CP"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Població:"
                label-for="input-poblacio"
              >
                <b-form-input
                  id="input-poblacio"
                  v-model="cliente.poblacion"
                  maxlength="50"
                  placeholder="Escriure Població"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Provincia:"
                label-for="input-provincia"
              >
                <b-form-input
                  id="input-provincia"
                  v-model="cliente.provincia"
                  maxlength="50"
                  placeholder="Escriure Provincia"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Dades Fiscals">
          <b-row>
            <b-col>
              <b-form-group label-class="font-weight-bold" label="Nom Fiscal:">
                <b-form-input
                  v-model="cliente.nombreFiscal"
                  placeholder="Enter name"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="NIF:"
                label-for="input-nif"
              >
                <b-form-input
                  id="input-nif"
                  maxlength="9"
                  v-model="cliente.nif"
                  placeholder="NIF"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="2">
              <b-form-group
                label="Tipus IVA:"
                label-class="font-weight-bold"
                label-for="input-iva"
              >
                <b-form-input
                  type="number"
                  :number="true"
                  min="0.00"
                  max="100"
                  required
                  id="input-iva"
                  v-model="cliente.tipoIVA"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Subtitulo:" label-class="font-weight-bold">
                <b-form-input
                  v-model="cliente.subtitulo"
                  maxlength="50"
                  placeholder="Escriure un subtitol per la factura"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Adreça Fiscal:">
                <b-form-textarea
                  v-model="cliente.direccionFiscal"
                  placeholder="Escriure Adreça Fiscal"
                  rows="2"
                  max-rows="3"
                  maxlength="200"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-class="font-weight-bold" label="CP:">
                <b-form-input
                  v-model="cliente.cpFiscal"
                  maxlength="5"
                  placeholder="Escriure CP"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label="Numero de Orden:" label-class="font-weight-bold">
                <b-form-input
                  v-model="cliente.ordenFiscal"
                  maxlength="20"
                  placeholder="Numero de Orden del Cliente"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Orden Concepto:" label-class="font-weight-bold">
                <b-form-input
                  v-model="cliente.ordenConceptoFiscal"
                  maxlength="50"
                  placeholder="Descripción del concepto de Orden del Cliente"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Vencimiento:">
                <b-form-select
                  v-model="cliente.tipoVencimiento"
                  :options="tiposVencimiento"
                  value-field="value"
                  text-field="text"
                >
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label-class="font-weight-bold" label="Població:">
                <b-form-input
                  v-model="cliente.poblacionFiscal"
                  maxlength="50"
                  placeholder="Escriure Població"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-class="font-weight-bold" label="Provincia:">
                <b-form-input
                  v-model="cliente.provinciaFiscal"
                  maxlength="50"
                  placeholder="Escriure Provincia"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label="Pais:" label-class="font-weight-bold">
                <b-form-select
                  v-model="cliente.paisFiscal"
                  :options="paises"
                  value-field="name"
                  text-field="name"
                >
                  <template #first>
                    <b-form-select-option :value="null"
                      >-- Seleccione un País --</b-form-select-option
                    >
                  </template>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
              <b-col>
                <b-form-group label="SWIFT:" label-class="font-weight-bold">
                  <b-form-input
                    v-model="cliente.swift"
                    maxlength="11"
                    placeholder="Swift Bancario"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Numero de Cuenta:" label-class="font-weight-bold">
                  <b-form-input
                    v-model="cliente.iban"
                    maxlength="24"
                    placeholder="IBAN"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group
                  label="Adeudo de Cobro:"
                  label-class="font-weight-bold"
                  label-for="input-adeudo"
                >
                <b-form-checkbox
                  v-model="cliente.isAdeudo"
                  name="check-button"
                  switch
                >
                No / Si
              </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
                <b-form-group label="Personas de Contacto:" label-class="font-weight-bold">
                  <b-form-input
                    v-model="cliente.personasContacto"
                    placeholder="Emails de las personas de contacto (separadas por ;)"
                  ></b-form-input>
                </b-form-group>
              </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
      <b-row>
        <b-col>
          <b-form-group
            label="Actiu:"
            label-class="font-weight-bold"
            label-for="input-rep"
          >
            <b-form-checkbox
              v-model="cliente.isActive"
              name="check-button"
              switch
            >
              Activar / Desactivar Centro
              <b>(Checked: {{ cliente.isActive }})</b>
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button class="mr-2" variant="outline-success" type="submit"
            >Gravar</b-button
          >
          <b-button class="mr-2" variant="outline-primary"
            ><router-link :to="{ name: 'Clients' }"
              >Cancel</router-link
            ></b-button
          >
        </b-col>
      </b-row>
      <b-form-input
        :hidden="true"
        type="text"
        v-model="cliente.identifier"
      ></b-form-input>
    </b-form>
    <b-row>
      <h3>
        Productes
        <b-button size="sm" variant="success" class="mr-2">
          <router-link
            :to="{
              name: 'CPAddFromClient',
              params: { cliente: cliente },
            }"
            class="icon"
          >
            + Nou Producte
          </router-link>
        </b-button>
      </h3>
    </b-row>
    <b-table
      :sticky-header="true"
      responsive
      striped
      hover
      :items="cliente.clienteProductos"
      :fields="Productfields"
    >
      <template v-slot:cell(accions)>
        <b-button
          @click="deleteProduct"
          size="sm"
          variant="danger"
          class="mr-2"
        >
          Delete
        </b-button>
        <b-button @click="editProduct" size="sm" variant="warning" class="mr-2">
          Editar
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import DataAccess from '@/Services/DataAccess.js'

export default {
  props: {
    cliente: {
      identifier: null,
      nombre: null,
      nif: null,
      cp: null,
      poblacion: null,
      provincia: null,
      direccion: null,
      pais: null,
      isActive: null,
      nombreFiscal: null,
      subtitulo: null,
      direccionFiscal: null,
      cpFiscal: null,
      ordenFiscal: null,
      ordenConceptoFiscal: null,
      poblacionFiscal: null,
      provinciaFiscal: null,
      paisFiscal: null,
      tipoIVA: 0,
      swift: null,
      iban: null,
      isAdeudo: false,
      personasContacto: null,
      tipoVencimiento : null,
    }
  },
  data () {
    return {
      show: true,
      paises: [],
      tiposVencimiento: [
        { value: '0', text: 'Contado' },
        { value: '1', text: '30 días' },
        { value: '2', text: '60 días' },
        { value: '3', text: '30 días, fin mes' },
      ],
      Productfields: [
        {
          key: 'productoTitulo',
          label: 'Titulo',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'productoPrecio',
          label: 'Precio',
          sortable: false
        },
        {
          key: 'isRecurrente',
          label: 'Recurrent',
          formatter: (value, key, item) => {
            return value ? 'Sí' : 'No'
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'isActive',
          label: 'Está Activo',
          formatter: (value, key, item) => {
            return value ? 'Sí' : 'No'
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'accions',
          label: 'Acciones'
        }
      ]
    }
  },
  created () {
    (async () => {
      await DataAccess.getData('/api/paises')
        .then((response) => {
          this.paises = response.data
        })
        .catch((error) => {
          console.log('ERROR: ', error)
        })
    })()
  },
  methods: {
    deleteProduct () {
      alert('DELETE')
    },
    editProduct () {
      alert('EDIT')
    },
    updateClient () {
      (async () => {
        await DataAccess.putData('/api/clients', this.cliente.identifier, {
          identifier: this.cliente.identifier,
          nombre: this.cliente.nombre,
          nif: this.cliente.nif,
          cp: this.cliente.cp,
          direccion: this.cliente.direccion,
          poblacion: this.cliente.poblacion,
          provincia: this.cliente.provincia,
          isActive: this.cliente.isActive,
          pais: this.cliente.pais,
          nombreFiscal: this.cliente.nombreFiscal,
          direccionFiscal: this.cliente.direccionFiscal,
          subtitulo: this.cliente.subtitulo,
          cpFiscal: this.cliente.cpFiscal,
          ordenFiscal: this.cliente.ordenFiscal,
          ordenConceptoFiscal: this.cliente.ordenConceptoFiscal,
          poblacionFiscal: this.cliente.poblacionFiscal,
          provinciaFiscal: this.cliente.provinciaFiscal,
          paisFiscal: this.cliente.paisFiscal,
          tipoIVA: this.cliente.tipoIVA,
          swift: this.cliente.swift,
          iban: this.cliente.iban,
          isAdeudo: this.cliente.isAdeudo,
          personasContacto: this.cliente.personasContacto,
          tipoVencimiento : this.cliente.tipoVencimiento,
        })
          .then((response) => {
            this.$router.push({ name: 'Clients' })
          })
          .catch((error) => {
            console.log('ERROR: ', error)
          })
      })()
    }
  }
}
</script>

<style scoped>
  .maxw {
    width: 80%;
    margin: 40px auto;
  }
</style>
